import {Validator} from '@/type/validation/result';
import { 必須入力, 日付書式 } from '@/type/validation/validator';

export interface 納品データ検索依頼型 {
  伝票日付From: Date;
  伝票日付To: Date | null;
  削除済検索対象区分: 削除済検索対象区分型;
}

export enum 削除済検索対象区分型 {
  削除済を含む = '削除済を含む',
  削除済を含まない = '削除済を含まない',
}

export enum 卸伝票区分型 {
  入庫 = '入庫',
  返品 = '返品',
}

export enum 削除済区分型 {
  未削除 = '未削除',
  削除済 = '削除済',
}

export interface 未入庫納品データ検索結果型 {
  未入庫納品伝票明細一覧: 未入庫納品伝票明細型[];
  アラートメッセージ: string;
}

export interface 未入庫納品伝票明細型 {
  卸名: string;
  卸伝票日付: Date;
  卸伝票区分: 卸伝票区分型;
  卸伝票番号: string;
  卸伝票行番号: number;
  JANコード: string;
  販売GTINコード: string;
  納品商品名: string;
  納品数: number;
  納品単価: number;
  納品合計金額: number;
  税率対象品目区分: string;
  納品薬価: number | null;
  ロット番号: string;
  有効期限: Date;
  税率区分基準日: number;
  削除済区分: 削除済区分型;
  商品登録済区分: string;
}

export const  納品データ検索依頼バリデータ一覧: Validator[] = [
  {
    name: '伝票日付From',
    constraints: [
      {method: 必須入力, message: '伝票日付Fromは入力が必要です'},
      {method: 日付書式, message: '伝票日付Fromの書式が不正です'},
    ],
  },
  {
    name: '伝票日付To',
    constraints: [
      {method: 日付書式, message: '伝票日付Toの書式が不正です'},
    ],
  },
];
